import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import PageWrapper from '../components/PageWrapper';

import catherineSmola1 from '../../assets/images/catherineSmola1.png';
import ScrollToTop from '../components/ScrollToTop';

const MessageFromPresident = (props) => {
  const { height, width, MAX_WIDTH, isMobile } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // var isIE = /*@cc_on!@*/false || !!document.documentMode;
  // var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));


  return (
    <PageWrapper height={height} showHeaderLogo maxWidth={MAX_WIDTH} isMobile={isMobile}>
      <Row style={{ marginTop: 120 }}>
        <Col>
          <Row>
            {!isMobile && width >= 576 && <Member />}
            <Col xs={12} sm={8} md={8} lg={9} xl={9}>
              <Row>
                {!isMobile && width < 576 && <Member />}
                <Col xs={7} sm={12}>
                  <h2
                    style={{ textAlign: 'left' }}
                    id="message-from-the-president"
                    tabIndex="-1"
                  >
                    {width < 576 ? 'mess- age' : 'message'} from {width < 576 ? 'PRES- IDENT' : 'president'}<br />& CEO
                  </h2>
                </Col>

              </Row>

              <div className="quoteSubheader" style={{ marginTop: 30 }}>
                The Property and Casualty (P&C) industry’s resilience, adaptability and drive for innovation were on full display once again in 2021. A second pandemic year further accelerated the digital evolution of the insurance customer experience and, in turn, the industry strived to ensure customer needs were met.
              </div>
              <p style={{ marginTop: 30 }}>
                CSIO is proud to support broker, insurer and vendor members during this time of transformation. For 40 years we have helped create Standards, programs and solutions, in addition to continually evolving these offerings to keep pace in an ever-changing industry.
              </p>
              <p>
                Whether it’s advancing eDocs, APIs, Data Standards and My Proof of Insurance, or our new website and Professional Development Program, the successes CSIO achieved by effectively collaborating with industry leaders in 2021 are worth celebrating. In this report, we highlight the ways CSIO ushered in the next generation of Data Standards and technology solutions to deliver on our strategic roadmap.
              </p>
              <ul
                className="letterFromPresidentBullets"
                style={{
                  marginLeft: 0,
                  paddingLeft: 0,
                  listStylePosition: 'inside',
                }}>
                <li>
                  <span style={{ fontWeight: 'bold' }}>Billing and Claims eDocs Notification Solutions</span> alleviated two of the three priority issues identified by CSIO’s Innovation and Emerging Technology (INNOTECH) Committee. They set the table for the Billing and Claims Working Groups to enable broker and insurer systems to securely and quickly exchange customer billing and claims information in the form of eDocs via CSIOnet. Insurers and vendors who program these digital notification solutions into their systems are eligible to apply for CSIO’s Billing or Claims eDocs Certification. Congratulations to The Wawanesa Mutual Insurance Company for being the first insurer to earn the Billing eDocs Certification!

                </li>
                <li style={{ marginTop: 30 }}>
                  <span style={{ fontWeight: 'bold' }}>Application Program Interface (API)</span> standardization was the third issue that the INNOTECH Committee prioritized. Standardizing APIs provides more fluid data exchange between broker and insurer systems resulting in an optimal user experience. The INNOTECH API Business Requirements and Technical Working Groups made significant headway with API standardization by defining business requirements for personal automobile and habitational insurance, Individually Rated Commercial Auto (IRCA) and Commercial General Liability (CGL) policy inquiry. They also broke new ground by publishing the first set of API Standards in the P&C industry in Java Script Object Notation (JSON), the latest technology for real-time API data interchange. JSON allows larger amounts of information to move between systems faster than ever before, which directly translates to brokers providing more seamless service to customers.
                </li>
                <li style={{ marginTop: 30 }}>
                  <span style={{ fontWeight: 'bold' }}>My Proof of Insurance (MPOI)</span> has come a long way since CSIO’s Board of Directors approved the eDelivery project in 2017. It has grown into a versatile solution that supports paperless initiatives by securely delivering electronic proof of auto insurance (eSlips), and other insurance policy documents.  Throughout the pandemic, members have increasingly embraced all the ways they can use MPOI to send policy documents to customers. This is very fitting as many of the solution’s features that CSIO has implemented since 2017 were inspired by valuable member feedback.
                </li>
                <li style={{ marginTop: 30 }}>
                  <span style={{ fontWeight: 'bold' }}>Commercial Lines (CL) Data Standards</span> have been on a steep upward trajectory since CSIO commissioned the Conference Board of Canada to map a path toward implementing common Standards in commercial insurance. Thanks to the outstanding efforts of our CL Working Group, CL Data Standards continue to reach new milestones, such as finalizing requirements for quoting multi-operations and binding small business, this year. In addition to the CL Working Group, Unica Insurance and Vertafore also deserve congratulations for becoming the first insurer and vendor members to achieve all three levels (Foundation, Verified, Certified) of CSIO’s CL Certification Program.
                </li>
                <li style={{ marginTop: 30 }}>
                  <span style={{ fontWeight: 'bold' }}>The Professional Development Program</span> (formerly eLearning) benefited from more than a rebranded name in 2021. CSIO continued producing free, accredited, on-demand courses and webinars that provide members with the skills needed to thrive in our industry. Over 1,400 new registrants enrolled in the program, dozens of them completed six courses to earn CSIO’s Digital Member designation. We expect to build on those strong numbers in 2022 as CSIO’s new website features enhance our members’ education experience.
                </li>
              </ul>
              <p>
                In 2022, CSIO and the Board of Directors will create a new strategic roadmap as our current one approaches the finish line. The next generation of Standards and solutions are already positively impacting the industry, however, they will need to give way to future generations in order for the P&C broker channel to continue elevating the customer experience. After seeing first-hand how effectively our Members, Committees, Working Groups, Board of Directors and CSIO employees collaborated in 2021, I’m confident we will continue celebrating our mutual success for years to come.
              </p>
              <p style={{ marginTop: 30 }}>
                Sincerely,<br /><br />Catherine Smola<br />CSIO<br />President & CEO
              </p>
            </Col>
          </Row>
        </Col>
      </Row>
      <ScrollToTop height={height} width={width} maxWidth={MAX_WIDTH} />
    </PageWrapper>
  )
}

export default MessageFromPresident;

const Member = ({ style }) => (
  <Col xs={5} sm={4} md={4}
    lg={3} xl={3} style={{
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      marginBottom: 25,
      ...style
    }}>
    <img
      src={catherineSmola1}
      style={{
        width: '100%',
        height: 'auto',
        marginLeft: 40,
        marginRight: 40,
      }}
      aria-label="Picture of Catherine Smola"
    />
    <div className="homepageExecName">
      CATHERINE SMOLA
    </div>
    <div className="homepageExecTitle">
      CSIO President<br />& CEO
    </div>
  </Col>
);
